<template>
	<div class="choose-page page">
		<van-nav-bar :title="navTitle" class="nav-bar choose-navbar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" size="18" @click="$router.push({path:'/'})" />
			</template>
		</van-nav-bar>

		<van-pull-refresh
			v-model="isLoading"
			@refresh="onRefresh"
			:success-text="$t('reservation.refresh')"
			:pulling-text="$t('choose.pull_to_refresh')"
			:loosing-text="$t('choose.release_to_refresh')"
			:loading-text="$t('choose.refreshing')"
			class="choose-pull"
		>
			<div class="choose-scroll-wrap">
				<!-- ========= 顶部：地区 Tabs ========= -->
				<div class="addr-bar" v-if="addlist && addlist.length > 0">
					<div class="addr-bar-inner">
						<div
							class="addr-item"
							:class="{active: curAddressId == v.id}"
							v-for="(v,k) in addlist"
							:key="'addr-'+k"
							@click="changeAddress(v)"
						>
							<span>{{ v.zh_cn }}</span>
							<div class="addr-item-line" v-if="curAddressId == v.id"></div>
						</div>
					</div>
				</div>

				

				<!-- ========= 老师卡片列表 ========= -->
				<div class="teacher-list" v-if="filteredTeachers && filteredTeachers.length > 0">
					<div
						class="teacher-card"
						v-for="(v,i) in filteredTeachers"
						:key="'teacher-'+i"
						@click="openDetail(v)"
					>
						<div class="teacher-img-wrap">
							<van-image
								class="teacher-img"
								:src="v.img_url"
								width="100%"
								height="100%"
								radius="12"
							>
								<template v-slot:loading>
									<van-loading type="spinner" size="20" />
								</template>
								<template v-slot:error>
									<div class="teacher-img-empty">
										<van-icon name="photograph" size="32" color="#bbb"/>
									</div>
								</template>
							</van-image>
						</div>

						<div class="teacher-info">
							<div class="teacher-title-row">
								<div class="teacher-names">
									<!-- V 认证徽章 + 昵称（对应用户给的参考样式） -->
									<div class="name-with-badge">
										<span class="v-badge">
											<svg xmlns="http://www.w3.org/2000/svg" class="v-badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
												<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
												<path d="m9 12 2 2 4-4"></path>
											</svg>
											<span class="v-badge-text">{{ $t('choose.v_verified') }}</span>
										</span>
										<span class="teacher-nick">{{ v.xuanfei_name }}</span>
									</div>
									<!--<span class="teacher-real" v-if="v.teacher_name">{{ v.teacher_name }}</span> -->
								</div>
							</div>

							<!-- 标签：放在名字下方（A/B 标签统一米黄圆角深棕样式） -->
							<div class="teacher-tags-below" v-if="splitTags(v.tag_a).length + splitTags(v.tag_b).length > 0">
								<div class="teacher-tags-row" v-if="splitTags(v.tag_a).length > 0">
									<span class="tag-badge" v-for="(t,ti) in splitTags(v.tag_a)" :key="'ca-'+ti">{{ t }}</span>
								</div>
								<div class="teacher-tags-row" v-if="splitTags(v.tag_b).length > 0">
									<span class="tag-badge" v-for="(t,ti) in splitTags(v.tag_b)" :key="'cb-'+ti">{{ t }}</span>
								</div>
							</div>

							<div class="teacher-base-row">
								<span class="base-item" v-if="v.age">{{ v.age }}{{ $t('choose.age_unit') }}</span>
								<span class="base-sep" v-if="v.age && v.height">·</span>
								<span class="base-item" v-if="v.height">{{ v.height }}cm</span>
								<span class="base-sep" v-if="(v.age||v.height) && v.weight">·</span>
								<span class="base-item" v-if="v.weight">{{ v.weight }}kg</span>
								<span class="base-sep" v-if="(v.age||v.height||v.weight) && v.education">·</span>
								<span class="base-item" v-if="v.education">{{ v.education }}</span>
							</div>

							<div class="teacher-city-row">
								<van-icon name="location-o" size="12" color="#999" class="city-icon"/>
								<span class="city-text" v-if="v.service_city">{{ v.service_city }}</span>
							<!--	<span class="city-text hometown" v-if="v.hometown">（户籍地：{{ v.hometown }}）</span> -->
							</div>

							<div class="teacher-action-row">
								<button type="button" class="detail-btn" @click.stop="openDetail(v)">{{ $t('choose.view_detail') }}</button>
							</div>
						</div>
					</div>
				</div>

				<!-- ========= 空状态 ========= -->
				<div class="empty-state" v-else>
					<svg viewBox="0 0 200 200" width="140" height="140" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<rect x="0" y="0" width="200" height="200" fill="none"/>
						<rect x="38" y="30" width="124" height="140" rx="14" fill="#f5f5f7" stroke="#e6e6eb" stroke-width="2"/>
						<circle cx="100" cy="80" r="24" fill="#e6e6eb"/>
						<path d="M58 146 C66 122 82 112 100 112 C118 112 134 122 142 146 Z" fill="#e6e6eb"/>
						<rect x="60" y="172" width="80" height="4" rx="2" fill="#ededf0"/>
					</svg>
					<p class="empty-text">{{ $t('choose.no_teacher') }}</p>
					<p class="empty-sub" v-if="teachers && teachers.length>0">{{ $t('choose.try_change_filter') }}</p>
				</div>
			</div>
		</van-pull-refresh>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isLoading: false,
			addlist: [],
			curAddressId: null,
			teachers: [],         // 该地区全部老师（后端返回）
			curTagA: null,        // 当前选中的标签A，null=全部
			curTagB: null         // 当前选中的标签B，null=全部
		};
	},
	computed: {
		// 导航标题：只有当多语言 foorter.choose 有真实值时才拼接“值 · 同城约课”
		// 否则只显示“同城约课”，避免出现两个重复字符串或“foorter.choose · 同城约课”
		navTitle() {
			const I18N_KEY = 'foorter.choose';
			const i18nVal = this.$t(I18N_KEY);
			const hasI18n = (
				i18nVal
				&& typeof i18nVal === 'string'
				&& i18nVal.trim().length > 0
				&& i18nVal !== I18N_KEY   // 没命中翻译时，vue-i18n 会原样返回 key
			);
			return hasI18n ? `${i18nVal} · ${this.$t('choose.appointment')}` : this.$t('choose.appointment');
		},
		// 从当前 teachers 合并去重得到筛选标签全集（走 splitTags，兼容 A,B,C 逗号分隔字符串）
		tagAOptions() {
			const s = new Set();
			(this.teachers||[]).forEach(v => {
				this.splitTags(v.tag_a).forEach(t => s.add(t));
			});
			return Array.from(s);
		},
		tagBOptions() {
			const s = new Set();
			(this.teachers||[]).forEach(v => {
				this.splitTags(v.tag_b).forEach(t => s.add(t));
			});
			return Array.from(s);
		},
		// 前端按标签 AND 过滤（走 splitTags 兜底）
		filteredTeachers() {
			let arr = Array.isArray(this.teachers) ? this.teachers : [];
			if (this.curTagA) {
				arr = arr.filter(v => this.splitTags(v.tag_a).indexOf(this.curTagA) !== -1);
			}
			if (this.curTagB) {
				arr = arr.filter(v => this.splitTags(v.tag_b).indexOf(this.curTagB) !== -1);
			}
			return arr;
		}
	},
	methods: {
		/**
		 * 统一解析 DB 里的标签字段，兼容后端可能的三种格式：
		 *   1) 数组（接口已经解析好的 ["钢琴","声乐"]）
		 *   2) JSON 字符串（未解码）
		 *   3) 逗号/中文逗号/空格/分号/换行分隔文本：A,B,C  或 钢琴，声乐，舞蹈
		 * 任何异常都返回 []
		 */
		splitTags(val) {
			if (val === null || val === undefined) return [];
			if (Array.isArray(val)) {
				return val.map(String).filter(t => (t || '').trim().length > 0);
			}
			let str = String(val).trim();
			if (!str) return [];
			// 先尝试 JSON
			try {
				let arr = JSON.parse(str);
				if (Array.isArray(arr)) {
					return arr.map(String).filter(t => (t || '').trim().length > 0);
				}
			} catch (e) {
				// 不是合法 JSON，忽略并继续按分隔符拆分（后台可能直接存 "A,B,C"）
			}
			// 再按分隔符拆（兼容逗号/中文逗号/分号/空格/换行）
			let parts = str.split(/[,，;；\s]+/).filter(t => t.trim().length > 0);
			return Array.from(new Set(parts.map(String)));
		},
		onRefresh() {
			this.reloadAll().finally(() => {
				this.isLoading = false;
			});
		},
		async reloadAll() {
			try {
				await this.getaddress_list();
				if (this.addlist && this.addlist.length > 0) {
					if (!this.curAddressId || !this.addlist.find(a => String(a.id) === String(this.curAddressId))) {
						this.curAddressId = this.addlist[0].id;
					}
					await this.getxuanfeilist();
				} else {
					this.teachers = [];
				}
			} catch (e) {
				console.warn('[choose] reloadAll err', e);
			}
		},
		changeAddress(v) {
			if (this.curAddressId === v.id) return;
			this.curAddressId = v.id;
			// 切地址时清空筛选（避免标签与该地区不匹配）
			this.curTagA = null;
			this.curTagB = null;
			this.getxuanfeilist();
		},
		getaddress_list() {
			return new Promise((resolve, reject) => {
				this.$http({
					method: 'get',
					url: 'address_list'
				}).then(res => {
					this.addlist = (res && res.data) ? res.data : [];
					resolve();
				}).catch(err => reject(err));
			});
		},
		getxuanfeilist() {
			return new Promise((resolve, reject) => {
				this.$http({
					method: 'get',
					url: 'xuanfeilist',
					data: { id: this.curAddressId }
				}).then(res => {
					this.teachers = (res && res.data) ? res.data : [];
					resolve();
				}).catch(err => reject(err));
			});
		},
		openDetail(v) {
			// 找到当前地区名
			let curName = '';
			const addr = (this.addlist || []).find(a => String(a.id) === String(this.curAddressId));
			if (addr) curName = addr.zh_cn;
			this.$router.push({
				path: '/profile',
				query: {
					id: v.id,
					name: curName,
					adsid: this.curAddressId
				}
			});
		}
	},
	created() {
		this.reloadAll();
	}
};
</script>

<style scoped>
.choose-page {
	background: #f7f8fa;
	min-height: 100vh;
}
.choose-navbar ::v-deep .van-nav-bar__content {
	background: linear-gradient(135deg, #7f5778 0%, #c98a9c 55%, #e5c2a0 100%);
}
.choose-navbar ::v-deep .van-nav-bar__title {
	color: #fff;
	font-weight: 600;
}
.choose-pull {
	min-height: calc(100vh - 46px);
}
.choose-scroll-wrap {
	padding-bottom: 20px;
}

/* 地区 Tab 条 */
.addr-bar {
	background: #fff;
	position: sticky;
	top: 0;
	z-index: 5;
	box-shadow: 0 1px 0 rgba(0,0,0,0.04);
}
.addr-bar-inner {
	display: flex;
	overflow-x: auto;
	padding: 0 6px;
	white-space: nowrap;
	-webkit-overflow-scrolling: touch;
}
.addr-bar-inner::-webkit-scrollbar { display: none; }
.addr-item {
	position: relative;
	padding: 14px 14px 12px;
	font-size: 28px;
	color: #666;
	flex-shrink: 0;
	cursor: pointer;
	transition: color .18s;
}
.addr-item.active {
	color: #111;
	font-weight: 600;
	font-size: 30px;
}
.addr-item-line {
	position: absolute;
	left: 50%;
	bottom: 4px;
	transform: translateX(-50%);
	width: 22px;
	height: 3px;
	border-radius: 2px;
	background: linear-gradient(90deg, #9a6c8f, #e5c2a0);
}

/* 筛选行 */
.filter-section {
	padding: 12px 14px 4px;
}
.filter-row {
	margin-bottom: 10px;
}
.filter-label {
	display: flex;
	align-items: center;
	font-size: 24px;
	color: #999;
	margin-bottom: 8px;
}
.dot {
	display: inline-block;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	margin-right: 6px;
}
.dot-a { background: linear-gradient(135deg,#ff6a88,#ff99ac); }
.dot-b { background: linear-gradient(135deg,#60a5fa,#7f5778); }

.filter-scroll {
	display: flex;
	overflow-x: auto;
	padding: 0 2px 2px;
	white-space: nowrap;
	-webkit-overflow-scrolling: touch;
}
.filter-scroll::-webkit-scrollbar { display: none; }
.filter-pill {
	flex-shrink: 0;
	display: inline-block;
	padding: 6px 12px;
	border-radius: 999px;
	font-size: 26px;
	line-height: 1.4;
	margin-right: 8px;
	transition: all .18s ease;
	cursor: pointer;
}
.pill-a {
	background: #fff4f6;
	color: #c75b7a;
	border: 1px solid transparent;
}
.pill-a.active {
	background: linear-gradient(135deg,#ff6a88,#ff99ac);
	color: #fff;
	box-shadow: 0 4px 10px rgba(255,118,150,0.25);
}
.pill-b {
	background: #f1f5ff;
	color: #4c6ef5;
	border: 1px solid transparent;
}
.pill-b.active {
	background: linear-gradient(135deg,#60a5fa,#7f5778);
	color: #fff;
	box-shadow: 0 4px 10px rgba(111,127,230,0.25);
}

/* 老师列表 */
.teacher-list {
	padding: 6px 14px 0;
}
.teacher-card {
	display: flex;
	background: #fff;
	border-radius: 16px;
	padding: 12px;
	margin-bottom: 12px;
	box-shadow: 0 2px 10px rgba(20,20,40,0.04);
}
.teacher-img-wrap {
	width: 120px;
	height: 150px;
	flex-shrink: 0;
	border-radius: 12px;
	overflow: hidden;
	background: #f2f3f5;
}
.teacher-img {
	width: 100%;
	height: 100%;
}
.teacher-img ::v-deep .van-image__img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.teacher-img-empty {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fafafa;
}

.teacher-info {
	flex: 1;
	min-width: 0;
	margin-left: 12px;
	display: flex;
	flex-direction: column;
}
.teacher-title-row {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
}
.teacher-names {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.teacher-nick {
	font-size: 36px;
	font-weight: 600;
	color: #1d1d1f;
}
.teacher-real {
	font-size: 26px;
	color: #888;
	margin-left: 8px;
}
.teacher-base-row {
	margin-top: 6px;
	font-size: 25px;
	color: #666;
	line-height: 1.5;
}
.base-item + .base-sep {
	margin: 0 4px;
	color: #d0d0d5;
}
.base-sep {
	color: #d0d0d5;
	margin: 0 4px;
}
.teacher-city-row {
	margin-top: 6px;
	font-size: 25px;
	color: #888;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}
.city-icon {
	margin-right: 4px;
	flex-shrink: 0;
}
.city-text.hometown {
	color: #aaa;
	margin-left: 2px;
}
/* 标签整体：放在名字下面，统一样式 */
.teacher-tags-below {
	margin-top: 10px;
}
.teacher-tags-row {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}
.teacher-tags-row + .teacher-tags-row {
	margin-top: 6px;
}
.tag-badge {
	display: inline-block;
	padding: 4px 10px;
	font-size: 24px;
	line-height: 1.4;
	border-radius: 6px;
	background: #f7ddc7;
	color: #3d2f1a;
	white-space: nowrap;
}
.teacher-action-row {
	margin-top: auto;
}
.detail-btn {
	border: none;
	outline: none;
	margin-top: 10px;
	width: 100%;
	padding: 14px 0;
	font-size: 26px;
	line-height: 1.4;
	font-weight: 500;
	border-radius: 999px;
	color: #2a2010;
	background: linear-gradient(to right, #e8d4b0, #d4b896, #c9a86c);
	cursor: pointer;
	box-shadow: 0 2px 4px rgba(0,0,0,0.06);
}
.detail-btn:active {
	transform: scale(0.97);
}

/* 空状态 */
.empty-state {
	padding: 60px 20px 20px;
	text-align: center;
	color: #999;
}
.empty-state svg { display: block; margin: 0 auto 10px; }
.empty-text {
	font-size: 30px;
	color: #888;
	margin: 8px 0 4px;
}
.empty-sub {
	font-size: 25px;
	color: #bbb;
}

/* V 认证徽章 + 昵称组合（卡片内尺寸，与已放大的系统字号对齐） */
.name-with-badge {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	max-width: 100%;
	flex-wrap: nowrap;
}
.v-badge {
	display: inline-flex;
	flex-shrink: 0;
	align-items: center;
	gap: 6px;
	padding: 6px 12px;
	border-radius: 6px;
	background-image: linear-gradient(to right, #d4b896, #b8956a);
	color: #3d2f1a;
}
.v-badge-icon {
	width: 28px;
	height: 28px;
	display: inline-block;
	flex-shrink: 0;
}
.v-badge-text {
	font-size: 24px;
	font-weight: 600;
	color: #3d2f1a;
	line-height: 1;
	white-space: nowrap;
}

/* 小屏：把图片缩小一点 */
@media (max-width: 360px) {
	.teacher-img-wrap {
		width: 104px;
		height: 132px;
	}
}
</style>
